import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { projects, destination }: Boundaries["transferProjects"]["request"],
): State {
  return [
    ...state,
    {
      request: setRequestStateToPending(),
      projects,
      destination,
    },
  ];
}

function handleSuccess(
  state: State,
  { destination }: Boundaries["transferProjects"]["success"],
): State {
  return state.map((item) =>
    item.destination.uuid === destination.uuid
      ? { ...item, request: setRequestStateToSuccess() }
      : item,
  );
}

function handleFailure(
  state: State,
  { destination }: Boundaries["transferProjects"]["failure"],
): State {
  return state.map((item) =>
    item.destination.uuid === destination.uuid
      ? { ...item, request: setRequestStateToFailure() }
      : item,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.transferProjectsRequested]: handleRequest,
    [events.transferProjectsSucceeded]: handleSuccess,
    [events.transferProjectsFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
